import React from "react";

export default function PhoneIcon({
  fill = "#000",
  size = { width: 24, height: 24 },
  className,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size.width}
      height={size.width}
      viewBox="0 0 24 24"
      className={className}
    >
      <defs>
        <path
          id="1aey22ry1a"
          d="M4.827 10.387c1.92 3.773 5.013 6.866 8.786 8.786l2.934-2.933c.373-.373.893-.48 1.36-.333 1.493.493 3.093.76 4.76.76.736 0 1.333.597 1.333 1.333v4.667c0 .736-.597 1.333-1.333 1.333C10.148 24 0 13.852 0 1.333 0 .98.14.641.39.391S.98 0 1.334 0H6c.736 0 1.333.597 1.333 1.333 0 1.667.267 3.267.76 4.76.147.467.04.987-.333 1.36l-2.933 2.934z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g transform="translate(-484 -420) translate(400 168) translate(32 88) translate(32 144) translate(20 20)">
                        <path d="M0 0H24V24H0z" />
                        <mask id="h4a2tb1i0b" fill="#fff">
                          <use xlinkHref="#1aey22ry1a" />
                        </mask>
                        <use
                          fill={fill}
                          fillRule="nonzero"
                          xlinkHref="#1aey22ry1a"
                        />
                        <path
                          fill={fill}
                          d="M0 0H24V24H0z"
                          mask="url(#h4a2tb1i0b)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
